import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ChevronDown } from 'lucide-react';
import axios from 'axios';

import '../../../../assets/css/screens/serviceprovider/dashboard/faq/Faq.css';
import WorkerNavbar from '../../../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';
import AppContext from '../../../../context/AppContext';



const FAQ = () => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);

  const [openId, setOpenId] = useState(null);
  const [faqs, setFaqs] = useState([]);

  const handleToggle = (id) =>
    setOpenId((prev) => (prev === id ? null : id));

  const handleBack = () => navigate(-1);

  // view worker faqs
  const viewFaqs = () => {
   axios.get(`${baseUrl}/viewa/worker/faqs`,{
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${localStorage.getItem("authToken") || ""}`
    }
  }

   )
         .then((response) => {
           setFaqs(response.data.workerfaqs);
         })
         .catch((error) => {
           console.log(error);
         });
  };
  
  const CardList = () => (
    <div className="faq-list">
      {faqs.map((faq, index) => {
        const isOpen = openId === faq.id;
        return (
          <div
            key={faq.id}
            className={`faq-card${isOpen ? ' faq-card--open' : ''}`}
            style={{ animationDelay: `${index * 0.05}s` }}
          >
            <button
              className="faq-question-row"
              onClick={() => handleToggle(faq.id)}
            >
              <span className="faq-question">
                {faq.question}
              </span>
              <span
                className={`faq-chevron${isOpen ? ' faq-chevron--open' : ''}`}
              >
                <ChevronDown size={18} />
              </span>
            </button>
            <div
              className={`faq-answer-wrap${isOpen ? ' faq-answer-wrap--open' : ''}`}
            >
              <p className="faq-answer">
                {faq.answer}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
  useEffect(() => {
    viewFaqs();
  }, []);
  return (
    <>
      <WorkerNavbar />
      <div className="faq-page">
        <div className="faq-desk-header">
          <button
            className="faq-back-btn"
            onClick={handleBack}
          >
            <ArrowLeft size={22} />
          </button>
          <h2 className="faq-desk-title">
            FAQs
          </h2>
        </div>
        <CardList />
      </div>
    </>
  );
};

export default FAQ;